<template>
    <div class="logo">
        <router-link to="/">
            <img class="logo-light" :src="makeImageLink('YGFzfNpuR3oTw1-7UEM0CA', lightLogo, 'logo')" alt="Corporate Logo"/>
        </router-link>
    </div>
</template>
<script>
    import ImageLink from "@/mixins/ImageLink";

    export default {
        name: 'Logo',
        mixins: [ImageLink],
        props: {
            url: {
                type: String,
                default: ''
            },
            lightLogo: {
                type: String,
                default: '7a7bb77c-ff2d-46db-26ff-702ac05b9400'
            },
        }
    }
</script>
